<div class="certifyWrapper">
    <header>
        <div class="container">
            <div class="wrapper d-flex align-items-center gap-3 justify-content-between">
                <figure>
                    <img class="header-logo" src="assets/images/header_logo.png" alt="Logo">
                </figure>
                <!-- <div class="text-white completText d-flex" *ngIf="isCertified"><strong>CERTIFICATE</strong>
                    <div class="completionText">OF COMPLETION</div>
                </div> -->
                <img class="verify_img" *ngIf="isCertified" src="assets/images/verified_white.png">
            </div>
        </div>

        <div class="dataFound certificateContainer" *ngIf="isCertified">
            <figure>
                <img src="assets/images/certified.svg" alt="" class="certificationData">
            </figure>
            <!-- <div class="heading3">Certificate Found!</div> -->
        </div>


    </header>


    <div class="d-flex success_details justify-content-center" *ngIf="isCertified && certificateData">
        <img class="user_img" [src]="certificateData.profileImage || 'assets/images/pro2.png'" alt="User Image">
        <div class="details">
            <div class="userName">{{ certificateData.username }}</div>
            <div class="hasCompleted">has completed the course Pathway</div>
            <div class="courseName">{{ certificateData.coursepath_name }}</div>
            <div class="issuedBy">Issued by <strong class="issuedOrg"> <img src="assets/images/edutechGradientLogo.svg" alt="EduTech Logo"></strong></div>
            <div class="d-flex issuedDate">
                <div>Issued Date</div>
                <div>{{ certificateData.issued_date | date: 'MMM d, yyyy' }}</div>
            </div>
        </div>
        <!-- <img class="verify_img" src="assets/images/verified.png"> -->
    </div>


    <div class="noDataFound certificateContainer" *ngIf="!isCertified">
        <figure>
            <img src="assets/images/no-categories.webp" alt="" class="certificationData noCertificationData">
        </figure>
        <div class="heading3">No Certificate Found!</div>
    </div>





    <footer class="certificateContainer">
        <div class="container">
            <div class="wrapper flx_column">
                <span class="copyrights">© {{ currentYear }} L&T EduTech. All rights reserved</span>
                <nav>
                    <a href="https://lntedutech.com/privacy-policy-2/">Privacy policy</a>
                </nav>
            </div>
        </div>
    </footer>
</div>